import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store'

const mentionChatState = (state: RootState) => state.mentionChat

export const selectMentionChat = createSelector(mentionChatState, (state) => state.chat)
export const selectIsLoading = createSelector(mentionChatState, (state) => state.isLoading)
